module.exports = ".container-fluid{\n    padding: 0px\n}\n \n@media (min-height: 950px) {\n    .container-fluid{\n        height: 100vh;\n    }  \n}"